// extracted by mini-css-extract-plugin
export default {"container":"ite_2gfYD","title":"ite_tit_3MjPB","items":"ite_ite_Ad0_3","item":"ite_ite_U4nPU","withShadow":"ite_wit_1AprP","card":"ite_car_1HkAs","withoutMaxWidth":"ite_wit_18Pvy"};